import Button from 'syf-component-library/ui/atoms/Button/Button';
import styled from 'styled-components';
export const OnlineChatButton = styled(Button) `
  display: inline-block;
  margin: 0;
  padding: 0;
`;
